// router/index.js
import { createRouter, createWebHistory } from "vue-router";
import GameCalendar from "../components/GameCalendar.vue";
import GameDetails from "../components/GameDetails.vue";
import NgdTerms from "../components/NgdTerms.vue";
import UnsubscribeGame from "../components/UnsubscribeGame.vue";
import UnsubscribeConfirmation from "../components/UnsubscribeConfirmation.vue";
// import Home from "../views/Home.vue";
// AUTHENTICATION - Temporarily disabled, can be re-enabled later
// import Login from "../components/Login.vue";
// import Signup from "../components/Signup.vue";
// import Profile from "../components/Profile.vue";
import axios from "axios";
import { API_BASE_URL } from "../api/config";
// import store from "../store";

const routes = [
  {
    path: "/",
    name: "GameCalendar",
    component: GameCalendar,
    meta: { title: "New Game Day - Your Ultimate Game Release Calendar" },
  },
  {
    path: "/game/:slug",
    name: "GameDetails",
    component: GameDetails,
    props: true,
    meta: { title: "New Game Day" },
  },
  {
    path: "/terms-and-conditions",
    name: "NgdTerms",
    component: NgdTerms,
    meta: { title: "New Game Day - Terms and Conditions" },
  },
  {
    path: "/unsubscribe",
    name: "UnsubscribeGame",
    component: UnsubscribeGame,
    props: (route) => ({ email: route.query.email }),
  },
  {
    path: "/unsubscribed",
    name: "UnsubscribeConfirmation",
    component: UnsubscribeConfirmation,
  },
  // AUTHENTICATION ROUTES - Temporarily disabled, can be re-enabled later
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login,
  //   meta: { requiresGuest: true },
  // },
  // {
  //   path: "/signup",
  //   name: "Signup",
  //   component: Signup,
  //   meta: { requiresGuest: true },
  // },
  // {
  //   path: "/profile",
  //   name: "Profile",
  //   component: Profile,
  //   meta: { requiresAuth: true, title: "New Game Day - Your Profile" },
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position, use it (like going back with the browser)
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top of the page
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  let baseTitle = to.meta.title;

  if (to.name === "GameDetails" && to.params.slug) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/games/${to.params.slug}`);
      const gameName = response.data.data.game.name;
      document.title = `${baseTitle} - ${gameName}`;
    } catch (error) {
      console.error("Failed to fetch game details:", error);
      document.title = baseTitle; // Fallback to base title
    }
  } else {
    document.title = baseTitle;
  }

  // AUTHENTICATION GUARDS - Temporarily disabled, can be re-enabled later
  // const isAuthenticated = store.getters.isAuthenticated;

  // Initialize auth state from localStorage
  // if (store.state.user === null) {
  //   store.dispatch("initAuth");
  // }

  // Routes that require a guest (not logged in)
  // if (to.meta.requiresGuest && isAuthenticated) {
  //   next("/");
  // }
  // Routes that require authentication
  // else if (to.meta.requiresAuth && !isAuthenticated) {
  //   next("/login");
  // }
  // Proceed as normal
  // else {
  //   next();
  // }

  // For now, always proceed without auth checks
  next();
});

export default router;
